import { ErrorService } from "@/services/error.service";
import { LogService } from "@/services/log.service";

const logger = new LogService();
const errorService = new ErrorService(logger);

export const useLogger = () => logger;
export const useErrorService = () => errorService;
